import React, { useState } from 'react';
import { Send } from 'lucide-react';

export default function ContactCTA() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section
      id="contact"
      style={{
        padding: '100px 24px',
        background: '#111827',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background decoration */}
      <div className="contact-decoration-1" style={{
        position: 'absolute',
        top: '-100px',
        right: '-100px',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'rgba(0, 153, 204, 0.08)',
        pointerEvents: 'none',
      }} />
      <div className="contact-decoration-2" style={{
        position: 'absolute',
        bottom: '-80px',
        left: '-80px',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'rgba(249, 115, 22, 0.06)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: '800px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <h2 style={{
            fontSize: 'clamp(28px, 3vw, 44px)',
            fontWeight: '700',
            color: 'white',
            marginBottom: '16px',
            lineHeight: 1.2,
            letterSpacing: '-0.5px',
          }}>
            How can we help you?
          </h2>
          <p style={{ fontSize: '18px', color: '#9CA3AF', lineHeight: 1.7 }}>
            Our Team will contact you promptly!
          </p>
        </div>

        {/* Contact form */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#D1D5DB', marginBottom: '8px' }}>Full Name</label>
              <input
                type="text"
                placeholder="John Doe"
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                required
                style={{
                  width: '100%',
                  padding: '14px 18px',
                  borderRadius: '10px',
                  border: '1px solid #374151',
                  background: 'rgba(255,255,255,0.05)',
                  color: 'white',
                  fontSize: '15px',
                  outline: 'none',
                  boxSizing: 'border-box',
                  transition: 'border-color 0.2s ease',
                }}
                onFocus={e => e.target.style.borderColor = '#0099CC'}
                onBlur={e => e.target.style.borderColor = '#374151'}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#D1D5DB', marginBottom: '8px' }}>Email Address</label>
              <input
                type="email"
                placeholder="john@company.com"
                value={formData.email}
                onChange={e => setFormData({ ...formData, email: e.target.value })}
                required
                style={{
                  width: '100%',
                  padding: '14px 18px',
                  borderRadius: '10px',
                  border: '1px solid #374151',
                  background: 'rgba(255,255,255,0.05)',
                  color: 'white',
                  fontSize: '15px',
                  outline: 'none',
                  boxSizing: 'border-box',
                  transition: 'border-color 0.2s ease',
                }}
                onFocus={e => e.target.style.borderColor = '#0099CC'}
                onBlur={e => e.target.style.borderColor = '#374151'}
              />
            </div>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#D1D5DB', marginBottom: '8px' }}>Tell us about your project</label>
            <textarea
              placeholder="Describe your project or idea..."
              value={formData.message}
              onChange={e => setFormData({ ...formData, message: e.target.value })}
              required
              rows={5}
              style={{
                width: '100%',
                padding: '14px 18px',
                borderRadius: '10px',
                border: '1px solid #374151',
                background: 'rgba(255,255,255,0.05)',
                color: 'white',
                fontSize: '15px',
                outline: 'none',
                resize: 'vertical',
                boxSizing: 'border-box',
                fontFamily: 'inherit',
                transition: 'border-color 0.2s ease',
              }}
              onFocus={e => e.target.style.borderColor = '#0099CC'}
              onBlur={e => e.target.style.borderColor = '#374151'}
            />
          </div>
          <div style={{ textAlign: 'center' }}>
            <button
              type="submit"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                backgroundColor: submitted ? '#16A34A' : '#F97316',
                color: 'white',
                padding: '16px 40px',
                borderRadius: '10px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600',
                transition: 'background-color 0.2s ease, transform 0.2s ease',
              }}
              onMouseEnter={e => { if (!submitted) { e.currentTarget.style.backgroundColor = '#EA580C'; e.currentTarget.style.transform = 'translateY(-1px)'; } }}
              onMouseLeave={e => { if (!submitted) { e.currentTarget.style.backgroundColor = '#F97316'; e.currentTarget.style.transform = 'translateY(0)'; } }}
            >
              {submitted ? 'Message Sent!' : 'Send Message'}
              <Send size={18} />
            </button>
          </div>
        </form>
      </div>

      <style>{`
        input::placeholder, textarea::placeholder {
          color: #6B7280;
        }
        @media (max-width: 640px) {
          .contact-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 768px) {
          .contact-decoration-1,
          .contact-decoration-2 {
            display: none !important;
          }
        }
      `}</style>
    </section>
  );
}
